<template>
  <div class="back-header">
    <a class="back-header-arrow-left" @click="handleClick">
      <slot name="content">{{ content }}</slot>
    </a>
    <slot>
      <div v-if="title" class="back-header-title">{{ title }}</div>
    </slot>
  </div>
</template>

<script>
  export default {
    name: 'FddBackHeader',
    props: {
      back: {
        type: [String, Object]
      },
      content: {
        type: String,
        default: '返回'
      },
      title: String
    },
    methods: {
      handleClick() {
        if (this.back) {
          this.$router.push(this.back)
        } else {
          this.$router.back()
        }
      }
    }
  }
</script>

<style scoped lang="less">
  @hoverColor: #67a8fa;
  @color: #276ef9;

  .back-header {
    font-size: 14px;
    height: 42px;
    display: flex;
    align-items: center;

    &-arrow-left {
      position: relative;
      padding-left: 15px;

      &:after {
        content: '';
        position: absolute;
        top: 3px;
        left: 3px;
        border-right: 2px solid @color;
        border-bottom: 2px solid @color;
        width: 6px;
        height: 6px;
        transform: matrix(-0.71, -0.71, -0.71, 0.71, 0, 0);
      }

      &:hover:after {
        border-right: 2px solid @hoverColor;
        border-bottom: 2px solid @hoverColor;
      }
    }

    &-title {
      &::before {
        content: '|';
        margin: 0 12px;
        display: inline-block;
        color: #5e5f61;
      }
    }
  }
</style>
